import moment from 'moment';
import UIHelper from '../../../../helpers/UIHelper';

const display = (value) =>
  value === null || value === undefined || value === '' ? '—' : value;

const displayBool = (value, t) =>
  value === true || value === false
    ? value
      ? t('Yes')
      : t('No')
    : display(value);

const formatInvoiceDate = (date, groupBy, t) => {
  if (!date || !moment(date).isValid()) {
    return '—';
  }
  switch (groupBy) {
    case 'day':
      return UIHelper.formatedDate(date, 'DD MMMM YYYY');
    case 'week':
      return `${t('Week')} ${moment(date).isoWeek()}, ${UIHelper.formatedDate(date, 'YYYY')}`;
    case 'month':
      return UIHelper.formatedDate(date, 'MMMM YYYY');
    case 'year':
      return UIHelper.formatedDate(date, 'YYYY');
    default:
      return `${t('Week')} ${moment(date).isoWeek()}, ${UIHelper.formatedDate(date, 'YYYY')}`;
  }
};

export const getInvoiceViewSections = (
  t,
  item,
  { groupBy, statusTexts } = {},
) => {
  const hasDailyRows = item?.allData?.invoices?.length > 0;
  if (!item?.id && !hasDailyRows) {
    return [];
  }

  const statusLabel = statusTexts?.[item.status] || display(item.status);

  return [
    {
      title: t('Riepilogo'),
      fields: [
        {
          text: t('Date'),
          value: formatInvoiceDate(item.invoice_date || item.date, groupBy, t),
        },
        { text: t('Insegna'), value: display(item.company_name) },
        {
          text: t('Outlet Village'),
          value: display(item.shopping_center_title),
        },
        { text: t('Stato'), value: statusLabel },
        { text: `${t('NETTO')} (€)`, value: display(item.taxable_sum) },
        { text: `${t('LORDO')} (€)`, value: display(item.taxable_vat_sum) },
        { text: t('SCONTRINI'), value: display(item.receipts_sum) },
        { text: t('PEZZI'), value: display(item.pieces_sum) },
        { text: t('Ingressi PdV'), value: display(item.visitors_sum) },
        { text: `${t('ATV')} €`, value: display(item.atv_sum) },
        { text: t('UPT'), value: display(item.upt_sum) },
        {
          text: t('CR PDV'),
          value:
            item.conversion_rate_sum != null
              ? `${item.conversion_rate_sum} %`
              : '—',
        },
        {
          text: t('Chiusura Sett.'),
          value: displayBool(item.week_closed, t),
        },
      ],
    },
  ];
};
